import React, { useContext, useEffect, useState } from 'react';
import GlobalContext from './../../../contexts/GlobalContext';
import { Card, Image, Button, Transition } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import CommentForm from './../../Forms/CommentForm';
import ModalTransition from '../../ModalTransition/ModalTransition';
import feedbackPos from './../../../assets/feedback-pos.png';
import feedbackNeg from './../../../assets/feedback-neg.png';
import feedbackNeutre from './../../../assets/feedback-start.png';

/**
 * Components ViewBooking
 * Widget pour le dashboard
 * @param {string} props.message
 */
const ViewBooking = props => {
  const [globalContext] = useContext(GlobalContext);

  const [feedbackState, setFeedBackState] = useState(feedbackNeutre);
  const [visibleState, setVisibleState] = useState(true);
  const [animationState, setAnimationState] = useState("");
  const [opinionMessageState, setOpinionMessageState] = useState(props.message);
  const [modalOpenState, setModalOpenState] = useState(false);

  useEffect(() => {
    if (modalOpenState === false) {
      feedbackCloseModal();
    }
  }, [modalOpenState]);// eslint-disable-line react-hooks/exhaustive-deps

  const feedbackChange = (ev, el) => {
    setVisibleState(false);
    setAnimationState("");

    const feedbackPosBtn = document.querySelector('#feedback-pos');
    const feedbackNegBtn = document.querySelector('#feedback-neg');

    if (el.icon === "thumbs up") {
      feedbackPosBtn.classList.add('disabled', 'loading');
      setAnimationState("slide right");

      setTimeout(() => {
        feedbackPosBtn.classList.remove('basic', 'loading');
        feedbackNegBtn.classList.remove('disabled', 'loading');
        feedbackNegBtn.classList.add('basic');
        setFeedBackState(feedbackPos);
      }, 300)

      setTimeout(() => {
        setVisibleState(true);
      }, 400)
      setOpinionMessageState(globalContext.translations.voteUp);
    } else {
      feedbackPosBtn.classList.remove('disabled');
      feedbackPosBtn.classList.add('basic');
      feedbackNegBtn.classList.add('disabled');
      feedbackNegBtn.classList.remove('basic');
      setAnimationState("slide left");
      setFeedBackState(feedbackNeg);
      setOpinionMessageState(globalContext.translations.voteDown);
      setTimeout(() => {
        setVisibleState(true);
      }, 200)
    }
  }

  const feedbackCloseModal = (ev, el) => {
    setVisibleState(false);
    setFeedBackState(feedbackNeg);

    if (modalOpenState) {
      toast.success(globalContext.translations.voteSuccessMessage);
    }

    setTimeout(() => {
      setVisibleState(true);
    }, 200)
    setOpinionMessageState(globalContext.translations.voteDown);
  }

  const handleCloseModal = () => {
    document.body.classList.remove('modal-fade-in');
    setModalOpenState(false);
  }

  return (
    <Card
      style={{ height: "300px" }}
      centered
    >
      <Card.Header>
        <Transition visible={visibleState} animation={animationState} duration={550}>
          <Image src={feedbackState} ui={true} />
        </Transition>
      </Card.Header>
      <Card.Content textAlign="center">
        <Card.Header className="p-1">{opinionMessageState}</Card.Header>
      </Card.Content>
      <Card.Content extra>
        <div className="ui two buttons">
          <Button id="feedback-pos" onClick={feedbackChange} icon="thumbs up" basic positive />
          <Button id="feedback-neg" onClick={(ev, el) => { feedbackChange(ev, el) }} icon="thumbs down" basic negative/>
          <ModalTransition
            size="tiny"
            open={modalOpenState}
            closeOnDimmerClick={false}
            handleClose={handleCloseModal}
            header="Voulez-vous laisser un commentaire ?"
            content={
              <CommentForm modal={setModalOpenState} />
            }
            actions={false}
          />
        </div>
      </Card.Content>
    </Card>
  )
}

export default ViewBooking;